import { ProfessionalSummaryDataTable } from '@frontend/components/pages/professionalSummaryData/ProfessionalSummaryDataTable';
import { translateKey } from '../../../../../translate';
import { TableBody, TableData, TableHead, TableHeader, TableRow } from '../../../../elements/common';
import { NullableFormattedDate } from '../../../../elements/NullableFormattedDate';

export interface IMedicijn {
    beginDatum: string;
    dosis: string;
    naam: string;
}

export interface IMedicijnenProps {
    medicijnen: IMedicijn[];
}

export function Medicijnen(props: IMedicijnenProps) {
    if (props.medicijnen.length === 0) {
        return null;
    }

    return (
        <ProfessionalSummaryDataTable isRead={true}>
            <TableHead>
                <TableRow>
                    <TableHeader>{translateKey('common.name')}</TableHeader>
                    <TableHeader>{translateKey('medications.dose')}</TableHeader>
                    <TableHeader align="right">{translateKey('medications.startDate')}</TableHeader>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.medicijnen.map((medicijn, i) => (
                    <TableRow key={i}>
                        <TableData>{medicijn.naam}</TableData>
                        <TableData>{medicijn.dosis}</TableData>
                        <TableData
                            align="right"
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            <NullableFormattedDate value={medicijn.beginDatum} />
                        </TableData>
                    </TableRow>
                ))}
            </TableBody>
        </ProfessionalSummaryDataTable>
    );
}
